import { useEffect } from "react";
import Hero from "../components/Hero";
import Featured from "../components/Featured";
import Brands from "../components/Brands";
import Range from "../components/Range";
// import WholeSale from "../components/WholeSale";
import AboutUs from "../components/AboutUs";
import NewsAlt from "../components/NewsAlt";
import ContactUs from "../components/ContactUs";
import Testimonials from "../components/Testimonial";
import { useFetch } from "../hooks/useFetch";

const Home = () => {
  const { data, loading } = useFetch(`/blog/all/1/9`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home">
      <Hero />
      <AboutUs />
      <Featured />
      {/* <Brands /> */}
      <Range />
      <Testimonials />
      {/* <WholeSale /> */}
      <NewsAlt data={data?.blogs?.slice(0, 4)} loading={loading} />
      <ContactUs />
    </div>
  );
};

export default Home;
